import {SLIDE_TYPES} from './slideTypes';
import {MODULE_TYPES} from './moduleTypes';

export const basicUser = {
    email: {
        isRequiredTrim: true,
        isValidEmail: true
    },
    fullName: {
        isRequiredTrim: true
    }
};

export const birthdays = {
    date: {
        isRequired: true,
        isValidDate: true
    },
    name: {
        isRequiredTrim: true
    }
};

export const birthdaySpreadsheet = {
    sheetUrl: {
        isRequiredTrim: true,
        matchesPattern: /^(http|https):\/\/docs\.google\.com\/spreadsheets\/d\/[^ "]+$/
    }
};

export const config = {
    'birthdays.image': {
        isRequiredIfModuleSelected: MODULE_TYPES.BIRTHDAYS.key
    },
    'birthdays.title': {
        isRequiredIfModuleSelected: MODULE_TYPES.BIRTHDAYS.key
    },
    defaultDuration: {
        isRequired: true,
        isInteger: true
    },
    groceriesChannel: {
        isRequiredIfModuleSelected: MODULE_TYPES.GROCERIES.key
    },
    'polish.sheetId': {
        isRequiredIfModuleSelected: MODULE_TYPES.POLISH.key
    },
    'polish.tabName': {
        isRequiredIfModuleSelected: MODULE_TYPES.POLISH.key
    },
    rooms: {
        isRequiredIfModuleSelected: MODULE_TYPES.ROOMS.key
    },
    timezone: {
        isValidTimezone: true
    },
   'spoc.defaultSpocImage': {
        isValidSpocWidthAsync: 430,
        isValidSpocHeightAsync: 688
    }
};

export const events = {
    description: {
        isRequiredIfFieldHasValue: {
            field: 'type',
            values: [SLIDE_TYPES.DEFAULT.key]
        }
    },
    duration: {
        isInteger: true
    },
    endDate: {
        isRequired: true,
        isValidDate: true
    },
    image: {
        isRequired: true
    },
    spocImage: {
        isValidSpocWidthAsync: 430,
        isValidSpocHeightAsync: 688,
        isRequiredIfFieldHasValue: {
            field: 'type',
            values: [SLIDE_TYPES.IMAGE.key]
        }
    },
    startDate: {
        isRequired: true,
        isValidDate: true
    },
    time: {
        isRequiredIfFieldHasValue: {
            field: 'isCountdown',
            values: [true]
        }
    },
    title: {
        isRequiredTrim: true,
        charsRemaining: 24
    },
    type: {
        isRequired: true
    },
    spocLayout: {
        isRequired: true
    }
};

export const groceries = {
    name: {
        isRequiredTrim: true
    }
};

export const login = {
    email: {
        isRequiredTrim: true
    },
    password: {
        isRequiredTrim: true
    }
};

export const offices = {
    key: {
        isRequired: true
    }
};

export const systemAnnouncements = {
    title: {
        isRequired: true
    },
    announcement: {
        isRequired: true
    },
    startDate: {
        isRequired: true,
        isValidDate: true
    },
    endDate: {
        isRequired: true,
        isValidDate: true
    }
};

export const passwordReset = {
    email: {
        isRequiredTrim: true,
        isValidEmail: true
    }
};

export const users = {
    email: {
        isRequiredTrim: true,
        isValidEmail: true
    },
    fullName: {
        isRequiredTrim: true
    },
    role: {
        isRequired: true
    }
};

export const videos = {
    title: {
        isRequiredTrim: true
    },
    url: {
        isRequiredTrim: true,
        isValidMediaUrl: true
    }
};


// WEBPACK FOOTER //
// ./src/constants/validationErrorRules.js